import { t } from '@moovly/i18n';

const getWeights = () => [
  {
    value: '100',
    label: t('fonts.weights.thin'),
  },
  {
    value: '200',
    label: t('fonts.weights.extraLight'),
  },
  {
    value: '300',
    label: t('fonts.weights.light'),
  },
  {
    value: '400',
    label: t('fonts.weights.normal'),
  },
  {
    value: '500',
    label: t('fonts.weights.medium'),
  },
  {
    value: '600',
    label: t('fonts.weights.semiBold'),
  },
  {
    value: '700',
    label: t('fonts.weights.bold'),
  },
  {
    value: '800',
    label: t('fonts.weights.extraBold'),
  },
  {
    value: '900',
    label: t('fonts.weights.black'),
  },
];
const getStyles = () => [
  {
    value: 'normal',
    label: t('fonts.styles.normal'),
  },
  {
    value: 'italic',
    label: t('fonts.styles.italic'),
  },
  {
    value: 'oblique',
    label: t('fonts.styles.oblique'),
  },
];
export { getStyles, getWeights };
